"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createGlobalStyles = void 0;

var _stylitas = require("@creditas/stylitas");

var _constants = require("./constants");

var createGlobalStyles = function createGlobalStyles(theme, overrideStyles) {
  return (0, _stylitas.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n\n  /**\n   * Best practice from http://callmenick.com/post/the-new-box-sizing-reset\n   * TLDR: It\u2019s easier to override and a slight performance boost.\n   */\n  *,\n  *::before,\n  *::after {\n    box-sizing: inherit;\n  }\n  html {\n    box-sizing: border-box;\n    [type='button'] {\n      appearance: none;\n    }\n  }\n  body {\n    color: #4a4a4a;\n    font-size: 16px;\n  }\n\n  /**\n   * Form elements don't inherit font settings.\n   * https://stackoverflow.com/questions/26140050/why-is-font-family-not-inherited-in-button-tags-automatically\n   */\n  html,\n  body,\n  input,\n  select,\n  optgroup,\n  textarea,\n  button {\n    font-weight: 400;\n    font-family: ", ";\n    font-feature-settings: 'kern';\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    overflow-x: hidden;\n    text-rendering: optimizeLegibility;\n  }\n\n  ", ";\n"])), _constants.FONTS, _constants.RESETS, _stylitas.utilities.typography.fontFamily(), overrideStyles);
};

exports.createGlobalStyles = createGlobalStyles;